<script lang="ts">
  import { page } from "$app/state";
  import { loginHref } from "#lib/entrance/login.ts";
  import { m } from "#messages";
  import type { ToastKind } from "./toast.svelte.ts";
  import Icon from "./Icon.svelte";
  import IconButton from "./IconButton.svelte";
  import { FOCUS_RING } from "./recipes.ts";

  let {
    kind,
    message,
    signIn = false,
    action = null,
    ondismiss,
  }: {
    kind: ToastKind;
    message: string;
    signIn?: boolean;
    action?: { readonly label: string; readonly run: () => void } | null;
    ondismiss: () => void;
  } = $props();
</script>

<div
  class={[
    "flex w-80 items-start gap-2 max-md:w-auto rounded-card border border-edge border-l-4 bg-surface-1 p-3 text-base text-ink-1",
    kind === "good" && "border-l-status-good",
    kind === "warning" && "border-l-status-warning",
    kind === "critical" && "border-l-status-critical",
  ]}
>
  <div class="flex flex-1 flex-col items-start gap-1.5">
    <p>{message}</p>
    {#if signIn}
      <a
        href={loginHref(page.url)}
        data-sveltekit-reload
        class="rounded-control font-medium text-accent-text underline-offset-2 hover:underline {FOCUS_RING}"
        data-testid="toast-sign-in"
      >
        {m.refusal_sign_in()}
      </a>
    {/if}
    {#if action !== null}
      <button
        type="button"
        onclick={action.run}
        class="rounded-control font-medium text-accent-text underline-offset-2 hover:underline {FOCUS_RING}"
        data-testid="toast-action"
      >
        {action.label}
      </button>
    {/if}
  </div>
  <IconButton label={m.ui_dismiss()} size="sm" onclick={ondismiss}>
    <Icon name="dismiss" size={12} />
  </IconButton>
</div>
